.expand {
  font-size: 0.8rem;
  color: var(--link);
  text-decoration: none;

  &:hover {
    color: var(--link-hover);
    text-decoration: underline;
  }

  &:active {
    color: var(--link-active);
  }

  svg {
    display: inline-block;
  }
}

.link {
  color: var(--gray-900);

  &:hover,
  &:active {
    color: var(--purple);
  }
}

.compact {
  & > h2 {
    margin-bottom: 0.3rem;
    font-size: 1rem;
  }

  & > h4 {
    margin-bottom: 0.3rem;
    font-size: 0.9rem;
  }

  & > p {
    margin-bottom: 0.3rem;
    font-size: 0.8rem;
  }
}

.list {
  padding-left: 0;

  li {
    padding: 0.5rem;
    margin-bottom: 1rem;
    list-style: none;
    background: #f8f9fa;
    border-radius: 5px;
  }
}
